import React from 'react';
import { connect } from 'react-redux';

import { formStatusDispatchHelper, formReset } from 'actions/FormStatusActions';

import ClientParentForm from 'components/forms/clients/ClientParentForm';

class ClientParentChangeForm extends React.Component {
  onSubmit = args => {
    const { client, onSubmit } = this.props;
    onSubmit(client.getUsername(), args);
  };

  render() {
    const { client, parentUsername, onSubmitParent, formStatus, close } = this.props;

    return (
      <ClientParentForm
        type="edit"
        onSubmit={this.onSubmit}
        onSubmitParent={onSubmitParent}
        data={client}
        parentUsername={parentUsername}
        formStatus={formStatus}
        close={close}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    formStatus: state.formStatus.holdingInfos,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onSubmit: (clientId, args) => {
      formStatusDispatchHelper('holdingInfos', `/api/clients/${clientId}/holdinginfos.json`, args, 'put', dispatch);
    },
    onFormSuccessfull: () => {
      dispatch(formReset('holdingInfos'));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClientParentChangeForm);
